export default __webpack_public_path__ + "static/media/Home-PT.9c5d2858.png";